import React from 'react';

const BigDamageChoosenIcon = () => {
  return (
    <svg width='150' height='80' viewBox='0 0 150 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3126_59425)'>
        <rect width='150' height='80' rx='2' fill='#E6F7FF' />
        <path
          d='M162.386 4.9502C162.237 9.07295 162.321 17.2615 163.85 17.0337M163.85 17.0337C165.763 16.7489 167.268 9.26282 167.634 7.83883M163.85 17.0337C160.823 18.7262 152.743 19.1764 149.082 19.19'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M116.72 13.179C120.482 14.8175 123.761 18.4706 124.823 20.1142C128.388 25.0795 128.77 38.1132 124.331 54.0271C120.739 66.9051 116.277 74.6863 111.844 79.6212C110.296 81.1513 108.633 82.9612 106.797 84.2789C99.9738 88.6318 88.4266 88.3443 86.2458 87.5055C84.9091 86.9914 82.6984 81.9016 82.6984 79.3824C84.3051 78.4954 85.4846 77.5465 86.7167 76.5198C90.2557 73.5706 92.1084 65.9989 93.5299 61.5124C94.4202 58.7026 96.9651 51.0115 99.4354 44.0828C100.132 41.9019 100.865 39.8904 101.608 38.1341C101.608 38.1341 101.678 37.9599 101.805 37.6468C102.562 35.7938 105.352 29.0747 107.726 24.7803C111.347 18.2308 116.72 13.179 116.72 13.179Z'
          fill='white'
        />
        <path
          d='M124.823 20.1142C123.761 18.4706 120.482 14.8175 116.72 13.179M82.6984 79.3824C82.6984 81.9016 84.9091 86.9914 86.2458 87.5055C88.4266 88.3443 99.9738 88.6318 106.797 84.2789M106.797 84.2789C103.981 85.869 100.639 85.924 98.7624 84.6555C90.8628 79.3169 95.9922 51.4214 101.608 38.1341M106.797 84.2789C108.633 82.9612 110.296 81.1513 111.844 79.6212'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M28.6076 89.9885C17.3071 90.2005 -8.15965 87.4272 -19.4805 86.0141V4.133L99.6335 -37.0098C102.93 -33.7744 112.764 -23.7326 112.672 -22.4995L141.6 -35.6395L167.644 -6.19849L162.016 5.54706L133.075 35.8266L128.04 40.9435C132.812 28.4639 133.706 6.99675 125.923 8.23875C122.349 8.80898 119.13 10.7848 116.295 13.4545C110.005 19.3768 105.603 28.7134 103.411 33.6928C100.591 40.0952 94.9513 57.0259 93.5299 61.5124C92.1084 65.9989 90.2556 73.5706 86.7167 76.5197C85.4846 77.5464 84.0451 78.5012 82.4384 79.3882C68.3206 87.1825 41.2899 89.7506 28.6076 89.9885Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.6076 7.43315C43.3717 0.809433 76.98 -11.8231 92.9394 -13.6091C99.7281 -14.3689 93.0599 -1.25143 88.7602 7.20697L88.6452 7.43315C87.1204 10.3276 81.8134 16.9127 72.7841 20.0969C69.8536 21.1304 66.133 22.503 62.2197 23.9796C62.8582 22.8327 63.596 21.555 64.3693 20.216C68.6102 12.8719 73.9158 3.68407 69.7341 4.13299C69.1655 4.19403 68.2552 4.30455 67.0746 4.44789C62.3857 5.01717 53.4325 6.10419 44.6809 6.66588C38.7119 7.04898 32.8658 7.33487 28.6076 7.43315Z'
          fill='#E6F7FF'
        />
        <path
          d='M28.6076 7.43315C6.18662 20.207 -1.95597 35.4233 -3.22464 41.4347C-4.76889 50.3798 28.6077 72.3882 37.8878 76.5197C47.1679 80.6513 61.7701 74.6051 60.6616 73.8997C59.5531 73.1943 29.5984 49.0295 30.33 42.2582C30.7296 38.5605 37.1335 34.0956 37.8878 33.6928C40.0739 32.5254 47.9021 29.4287 56.9744 25.9688C59.6435 21.204 63.7377 11.5963 62.2197 9.5428C60.7016 7.48927 49.8947 6.76921 44.6809 6.66588C38.7119 7.04898 32.8658 7.33487 28.6076 7.43315Z'
          fill='#E6F7FF'
        />
        <path
          d='M44.6809 6.66588C49.8947 6.76921 60.7016 7.48927 62.2197 9.5428C63.7377 11.5963 59.6435 21.204 56.9744 25.9688C58.6883 25.3152 60.4466 24.6486 62.2197 23.9796C62.8582 22.8327 63.596 21.555 64.3693 20.216C68.6102 12.8719 73.9158 3.68407 69.7341 4.13299C69.1655 4.19403 68.2552 4.30455 67.0746 4.44789C62.3857 5.01717 53.4325 6.10419 44.6809 6.66588Z'
          fill='#E6F7FF'
        />
        <path
          d='M-20 80.1741C-11.5903 81.7218 5.80453 84.6325 12.5012 82.572C17.7767 80.9488 -5.46483 64.1632 -10.5031 61.7302C-13.636 60.2173 -16.9041 59.0814 -19.7786 58.6295L-20 80.1741Z'
          fill='#E6F7FF'
        />
        <path
          d='M-19.4805 4.13299C-13.4183 4.71429 -3.38927 5.60276 6.33542 6.31145M28.6076 7.43315C6.18662 20.207 -1.95597 35.4233 -3.22464 41.4347C-4.76889 50.3798 28.6077 72.3882 37.8878 76.5197C47.1679 80.6513 61.7701 74.6051 60.6616 73.8997C59.5531 73.1943 29.5984 49.0295 30.33 42.2582C30.7296 38.5605 37.1335 34.0956 37.8878 33.6928C40.0739 32.5254 47.9021 29.4287 56.9744 25.9688M28.6076 7.43315C43.3717 0.809434 76.98 -11.8231 92.9394 -13.6091M28.6076 7.43315C24.2685 7.43315 17.6095 7.08689 10.4378 6.60043M28.6076 7.43315C32.8658 7.33487 38.7119 7.04898 44.6809 6.66588M92.9394 -13.6091L112.672 -22.4995M92.9394 -13.6091C99.7281 -14.3689 93.0599 -1.25143 88.7602 7.20697M88.6452 7.43315C87.1204 10.3276 81.8134 16.9127 72.7841 20.0969C69.8536 21.1304 66.133 22.503 62.2197 23.9796M88.6452 7.43315L88.7602 7.20697M88.6452 7.43315C88.6833 7.35814 88.7217 7.28274 88.7602 7.20697M62.2197 23.9796C60.4466 24.6486 58.6883 25.3152 56.9744 25.9688M62.2197 23.9796C62.8582 22.8327 63.596 21.555 64.3693 20.216C68.6102 12.8719 73.9158 3.68408 69.7341 4.13299C69.1655 4.19404 68.2552 4.30455 67.0746 4.44789C62.3857 5.01718 53.4325 6.1042 44.6809 6.66588M141.6 -35.6395L135.238 -32.6665M10.4378 6.60043C1.28921 13.3708 -17.3634 28.8841 -20 31.7305M10.4378 6.60043C9.08456 6.50863 7.71304 6.41184 6.33542 6.31145M6.33542 6.31145C3.86169 7.98261 -1.51354 11.3778 -3.22464 11.5893C-4.93574 11.8009 -15.1212 11.6775 -20 11.5893M6.33542 6.31145C2.89847 9.34867 -4.35541 15.3735 -5.69401 15.8197C-8.07361 16.6129 -14.7497 17.0756 -20 16.6129M-19.4805 86.0141C-8.15964 87.4272 17.3071 90.2005 28.6076 89.9885C41.2899 89.7506 68.3206 87.1825 82.4384 79.3882C84.0451 78.5012 85.4846 77.5464 86.7167 76.5197C90.2556 73.5706 92.1084 65.9989 93.5299 61.5124C94.9514 57.0259 100.591 40.0952 103.411 33.6928C105.603 28.7134 110.005 19.3768 116.295 13.4545C119.13 10.7848 122.349 8.80898 125.923 8.23874C133.706 6.99675 132.812 28.4639 128.04 40.9435L133.075 35.8266M167.644 -6.19849L162.016 5.54706L133.075 35.8266M135.238 -32.6665C138.301 -23.9916 142.156 1.85178 133.075 35.8266M135.238 -32.6665L115.278 -23.6737M44.6809 6.66588C49.8947 6.76922 60.7016 7.48927 62.2197 9.5428C63.7377 11.5963 59.6435 21.204 56.9744 25.9688M112.672 -22.4995C112.764 -23.7326 102.93 -33.7744 99.6335 -37.0098M112.672 -22.4995L115.278 -23.6737M115.278 -23.6737C115.73 -25.9734 117.158 -31.4029 119.258 -34.7237M-20 80.1741C-11.5903 81.7218 5.80453 84.6325 12.5012 82.572C17.7767 80.9488 -5.46483 64.1632 -10.5031 61.7302C-13.636 60.2173 -16.9041 59.0814 -19.7786 58.6295L-20 80.1741Z'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M124.287 54.0506C122.496 60.4744 120.188 66.2911 117.674 71.0571C115.158 75.8269 112.443 79.5294 109.843 81.7393C107.627 83.6241 105.545 84.3829 103.759 83.8847C102.262 83.4674 101.045 82.1896 100.146 80.1569C99.2477 78.1262 98.6837 75.3773 98.4769 72.0944C98.0634 65.531 99.0808 56.89 101.635 47.7322C104.189 38.5744 107.791 30.6543 111.542 25.2525C113.419 22.5506 115.324 20.4905 117.144 19.218C118.965 17.9442 120.668 17.4808 122.164 17.8981C122.961 18.1205 123.677 18.5857 124.309 19.2785C125.342 20.4119 126.144 22.1484 126.69 24.3869C127.236 26.622 127.521 29.3384 127.535 32.4122C127.562 38.5594 126.502 46.1115 124.287 54.0506Z'
          fill='white'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M121.08 53.9224C119.747 58.7 118.054 63.0318 116.226 66.5863C114.395 70.1447 112.436 72.909 110.578 74.5654C108.989 75.9816 107.53 76.5408 106.308 76.1999C105.285 75.9144 104.446 75.0048 103.83 73.5134C103.215 72.0256 102.842 70.0003 102.726 67.5712C102.496 62.7156 103.3 56.3043 105.199 49.493C107.099 42.6817 109.73 36.78 112.44 32.7447C113.796 30.7259 115.164 29.1864 116.46 28.2314C117.759 27.2742 118.948 26.9301 119.971 27.2156C120.517 27.3678 121.008 27.6958 121.442 28.1946C122.153 29.0123 122.703 30.2797 123.069 31.9302C123.433 33.5767 123.609 35.5836 123.59 37.86C123.55 42.4123 122.727 48.0178 121.08 53.9224Z'
          fill='#E6F7FF'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M114.91 48.9714C116.504 42.2318 114.012 35.2012 112.684 32.6223C112.684 32.6223 113.564 31.1071 114.313 30.2842C115.027 29.5007 116.337 28.3469 116.337 28.3469C116.985 29.342 119.762 41.5785 114.91 48.9714Z'
          fill='white'
        />
        <path
          d='M112.684 32.6222C114.012 35.2012 116.504 42.2318 114.91 48.9714C119.762 41.5785 117.022 29.5136 116.373 28.5186'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M115.696 48.8132C119.131 45.258 121.468 34.5745 122.146 29.5527C122.146 29.5527 123.03 31.4403 123.311 33.1099C123.593 34.7795 123.435 36.3869 123.435 36.3869C120.151 46.4751 114.749 49.7931 115.696 48.8132Z'
          fill='white'
        />
        <path
          d='M122.175 29.3906C121.497 34.4123 119.13 45.258 115.695 48.8132C114.748 49.7931 120.264 46.2865 123.548 36.1983'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M113.289 50.8431C111.503 50.423 107.377 48.6447 105.682 47.8745C105.682 47.8745 104.907 50.4764 104.471 52.281C104.035 54.0857 103.499 57.2061 103.499 57.2061C105.905 57.5551 111.657 55.4789 112.643 54.3236L112.966 52.5833L113.289 50.8431Z'
          fill='white'
        />
        <path
          d='M105.845 47.9624C107.541 48.7326 111.503 50.4232 113.289 50.8433M112.643 54.3238C111.657 55.4791 105.607 57.6175 103.738 57.2499'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M122.146 48.7073C120.416 50.3264 117.538 50.5287 116.152 50.4459C116.152 50.4459 116.152 51.5038 115.927 52.2913C115.724 53.0038 115.407 54.1037 115.407 54.1037C116.167 54.4496 119.504 55.109 120.739 54.5482C120.739 54.5482 121.125 53.9251 121.677 51.6375C121.951 50.497 122.146 48.7073 122.146 48.7073Z'
          fill='white'
        />
        <path
          d='M116.152 50.4457C117.538 50.5285 120.587 50.2236 122.317 48.6046M115.507 54.1416C116.268 54.4875 119.553 55.0972 120.788 54.5365'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M112.989 71.6586C114.922 65.0573 114.223 58.7221 113.978 56.1272C114.853 56.1272 116.605 58.066 116.143 66.4527C116.143 66.4527 115.699 67.6532 114.735 69.2305C114.017 70.4059 112.989 71.6586 112.989 71.6586Z'
          fill='white'
        />
        <path
          d='M112.983 71.878C114.915 65.2766 114.223 58.7221 113.978 56.1272C114.853 56.1272 116.639 58.2649 116.177 66.6515'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M113.061 55.9773C111.307 62.7542 106.006 69.3451 103.575 71.7935C103.575 71.7935 103.173 72.1051 104 73.9124C104.824 75.7115 105.494 75.4393 105.494 75.4393C112.337 67.5901 113.39 59.1941 113.061 55.9773Z'
          fill='white'
        />
        <path
          d='M103.575 71.7935C106.006 69.3451 111.307 62.7542 113.062 55.9773C113.391 59.1941 112.338 67.5901 105.494 75.4393'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M121.08 53.9224C119.747 58.7 118.054 63.0318 116.226 66.5863C114.395 70.1447 112.436 72.909 110.578 74.5654C108.989 75.9816 107.53 76.5408 106.308 76.1999C105.285 75.9144 104.446 75.0048 103.83 73.5134C103.215 72.0256 102.842 70.0003 102.726 67.5712C102.496 62.7156 103.3 56.3043 105.199 49.493C107.099 42.6817 109.73 36.78 112.44 32.7447C113.796 30.7259 115.164 29.1864 116.46 28.2314C117.759 27.2742 118.948 26.9301 119.971 27.2156C120.517 27.3678 121.008 27.6958 121.442 28.1946C122.153 29.0123 122.703 30.2797 123.069 31.9302C123.433 33.5767 123.609 35.5836 123.59 37.86C123.55 42.4123 122.727 48.0178 121.08 53.9224Z'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M115.813 52.9113C115.396 54.4066 114.687 55.5556 114.044 56.0093C113.775 56.1993 113.553 56.2432 113.382 56.1954C113.238 56.1551 113.098 56.0423 112.978 55.8275C112.857 55.6114 112.766 55.3091 112.718 54.9327C112.623 54.1811 112.706 53.1846 113.001 52.127C113.296 51.0694 113.741 50.1737 114.211 49.5799C114.447 49.2825 114.681 49.0708 114.896 48.9486C115.111 48.827 115.288 48.8027 115.433 48.843C115.511 48.8648 115.586 48.907 115.657 48.9732C115.9 49.2002 116.083 49.6949 116.125 50.4169C116.166 51.1237 116.069 51.9954 115.813 52.9113Z'
          fill='white'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M55.3543 16.0761C55.3543 19.9373 52.7881 22.9806 49.7195 22.9806C46.651 22.9806 44.0847 19.9373 44.0847 16.0761C44.0847 12.215 46.651 9.17163 49.7195 9.17163C52.7881 9.17163 55.3543 12.215 55.3543 16.0761Z'
          stroke='#335566'
          strokeWidth='0.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M49.8511 42.3745H53.0434'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M49.0909 43.4382H51.3711'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M48.6342 44.3499H50.0023'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M46.9627 45.11C49.7799 45.11 55.6107 44.7384 55.6107 44.7384L59.9149 44.468'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M47.2663 46.1748L55.8284 46.0826'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M48.6342 46.9343H50.7624'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M53.7567 45.4954H55.8849'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M48.3308 47.8469H51.8271'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M84.739 52.7106C83.6079 52.7106 83.0059 52.5199 84.2069 51.6465C84.8664 51.9762 84.1474 52.1481 84.967 52.1025C85.2447 52.0871 86.8767 51.157 86.6307 52.0181C86.4975 52.4842 85.1304 52.7106 84.739 52.7106Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M64.8992 42.9822H67.6355'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M68.3968 41.9177H72.0451'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M58.2112 41.7659H61.4035'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M60.7955 41.3093H65.0519'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M66.9508 42.4353H71.2072'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M50.9149 37.9648H56.3875'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M54.5538 39.6199H60.0263'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M52.7392 36.2937H56.6916'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M54.5538 35.603H58.5062'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M66.7244 64.8724C69.6151 64.8724 72.2398 64.9681 74.967 63.994C77.0927 63.2349 79.0681 63.2002 81.3178 63.2002'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M67.0297 66.8482C69.4793 66.2718 71.9002 65.5503 74.3433 64.9396C75.2392 64.7156 76.0457 64.46 77.0711 64.0359C78.4699 63.5334 79.2188 63.2317 80.4141 63.2317'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M69.1563 68.0644C72.4426 68.0644 75.2524 66.8614 78.2687 65.7081C80.06 65.0232 81.8795 64.2956 83.6568 63.5715C85.9957 62.6186 88.074 61.5761 90.4225 60.1211'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M80.8625 62.4398C82.9526 62.4398 85.049 62.4808 87.0106 61.6713C88.5567 61.0332 90.0302 60.3448 91.5035 59.5515'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M81.9263 61.3761C83.5691 61.3761 84.7949 61.3136 86.5205 60.7681C87.7671 60.3739 89.5608 59.3662 89.5608 59.3662C89.5608 59.3662 91.389 58.1383 92.4153 57.7278'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M59.2753 31.7334C58.0982 31.7334 59.6466 30.9066 60.0354 30.8213H60.5674C61.3092 30.8213 60.9192 30.8566 60.6434 31.2013C60.3995 31.5063 59.662 31.7334 59.2753 31.7334Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M62.1967 29.4527C62.4606 28.7742 63.5824 28.6315 64.1392 28.5406C64.835 28.0187 64.4232 28.4408 65.2033 28.0508C65.6119 27.8464 65.778 27.7805 66.2674 27.7805C66.8353 27.7805 65.8612 28.3947 65.6593 28.5068C64.9282 28.913 63.8282 29.0703 63.2271 29.6047C63.0617 29.7517 62.0339 29.8714 62.1967 29.4527Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M73.5774 26.1295C72.5242 25.6614 72.3613 25.5004 72.3613 24.1195C71.7479 23.8128 72.6886 23.5853 73.2826 23.8493C74.1625 24.2403 74.4987 23.8395 74.4987 24.9978C74.4987 25.5852 74.4206 26.5042 73.5774 26.1295Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M79.1132 27.8481C78.2842 27.2033 78.7878 25.0793 79.1892 24.3602C80.4629 24.7848 80.7403 25.4293 81.5876 23.9041C81.9189 23.3079 82.6855 23.5712 82.6855 24.3602C82.6855 24.8317 82.5516 26.1084 81.9254 26.1084C81.3375 26.1084 81.2985 25.3211 80.6418 25.5087C80.3246 25.5994 80.2653 26.8631 80.1351 27.1725C79.9095 27.7082 79.8606 28.4294 79.1132 27.8481Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M84.0204 29.4524C84.2795 28.8696 84.238 28.6979 84.9663 28.3883C85.5193 28.1118 85.6573 28.1887 86.1486 27.7465C86.3291 27.584 86.5501 27.3798 86.6722 27.1722C87.1231 26.4058 87.281 27.5298 87.3647 27.8647C87.4061 28.0304 87.6559 29.1106 87.7363 29.0302C87.9403 28.8262 88.3067 28.5551 88.6146 28.7261C89.2229 29.0641 89.2227 30.5642 89.2227 31.1419L89.2227 31.1584C89.2227 31.8523 89.37 31.7858 88.9187 31.5469C88.5019 31.3262 86.8157 31.1221 86.7905 30.6686C86.7704 30.3079 87.0155 28.543 86.3344 29.1484C86.0664 29.3867 85.6059 29.3184 85.2703 29.4862C84.9823 29.6302 84.6794 30.0427 84.3582 30.0605C83.8562 30.0884 83.8314 29.8777 84.0204 29.4524Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M91.6549 34.7729C91.6549 34.149 92.2065 33.2924 92.567 32.7967C92.8697 32.1914 95.4912 33.5593 93.5129 34.3506C93.2087 34.4723 91.6549 35.6705 91.6549 34.7729Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M94.4172 35.9492C94.6831 35.4706 94.726 35.5692 95.4052 35.5692C96.0871 35.5692 95.4958 35.7212 96.1653 35.7212C97.3998 35.7212 96.6163 36.0457 96.0809 36.3377C95.6114 36.5938 94.9931 36.787 94.4256 36.6248C94.2358 36.5706 94.3526 36.0654 94.4172 35.9492Z'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M97.3554 39.3815C96.963 39.3815 96.2913 39.168 96.2913 39.6856'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M91.9127 36.8378C90.0928 36.6972 88.9448 37.219 90.5683 37.219'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M80.3205 42.4353H82.7704H85.0003'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M79.0368 43.1343H86.7896'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M80.2538 44.3499H85.1182'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M79.4933 45.8701C80.8674 45.8701 82.2102 45.8701 83.5728 45.8701'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M77.5175 45.4138H83.5981'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M80.4058 51.6465H83.4461'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M81.0139 53.167H83.9021'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M80.5587 55.7512H82.687'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M81.9263 55.1432C82.7032 55.1432 84.2877 55.4438 84.9666 54.9912'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M84.2052 56.8159C85.5809 56.7899 86.7214 56.3318 88.0055 55.9038'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M82.2295 58.9439C83.111 58.9439 83.8718 59.0462 84.6618 58.6399C85.0306 58.4502 85.3205 58.2852 85.7259 58.1838'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M81.9263 60.1593C83.2617 60.1593 84.5549 60.1397 85.8787 60.0073'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M82.0774 50.2786C83.6443 50.2786 85.117 50.3548 86.6378 49.9746'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeMiterlimit='16'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M44.5133 45.4954H46.8042' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M43.7487 44.1978H46.4977' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M45.1991 47.5576H47.9481' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M49.6292 40.7605H50.011' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M49.4748 40.1504H50.7729' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M54.9735 41.3118H55.3553' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M45.5321 46.8179L46.7647 46.7867' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M54.8216 40.7004H56.1197' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M50.0872 39.3872H51.4617' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M50.9276 38.3943H53.9057' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M53.9803 40.1504H56.9584' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M52.5302 35.7976L54.2557 35.8056' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M53.0646 35.0344H55.05' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M53.6747 34.499H56.271' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M56.9591 32.5908H59.7844' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M60.2434 32.1323H62.6106' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M61.4252 31.2764H64.5307' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M61.4252 30.666H63.5633' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M67.3444 27.9326H71.3151' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M67.4201 27.2456H70.0164' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M69.4059 28.4304H72.0022' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M67.8791 26.3291H69.9408' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M71.3152 26.4062H72.4607' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M70.1285 25.938L72.0013 25.9352' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M70.7045 25.3359H72.1553' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M83.303 28.0854H84.3721' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M82.0183 28.5532L84.0662 28.5552' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M82.7688 29.1548H83.227' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M90.5576 37.4783H91.3976' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M90.7105 38.2417H91.7796' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path
          d='M80.4778 48.4738C81.4215 48.4738 82.3661 48.3975 83.3031 48.3975'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeLinecap='round'
        />
        <path d='M83.2275 48.7029H86.0529' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path
          d='M81.1657 56.4921C82.1025 56.4921 82.9828 56.4158 83.9147 56.4158'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeLinecap='round'
        />
        <path d='M82.0359 52.7107H83.3341' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M80.9754 52.179H82.8081' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M81.0139 49.0574H82.8465' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path
          d='M68.8709 67.5641C70.9402 67.5641 72.9743 67.3987 74.9034 66.6095C75.6786 66.2924 77.19 65.426 77.19 65.426C77.19 65.426 78.3602 64.7791 79.134 64.4595'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeLinecap='round'
        />
        <path
          d='M73.3011 68.4806C75.1188 68.4806 76.6652 68.2325 78.5072 67.2461C79.0093 66.9773 79.7418 66.4697 79.7418 66.4697C79.7418 66.4697 80.4354 65.9293 80.6828 65.7927'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeLinecap='round'
        />
        <path
          d='M75.6677 67.4114C78.0629 67.3329 80.3504 65.4265 82.2298 64.1736'
          stroke='#FF9700'
          strokeWidth='0.2'
          strokeLinecap='round'
        />
        <path d='M56.8825 54.8884H58.9443' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M57.7225 53.8198H59.4788' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M58.4102 53.2847H60.701' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M59.1731 52.2917H60.853' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M59.5551 51.9099H61.6932' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <path d='M60.0139 50.8413H62.6865' stroke='#FF9700' strokeWidth='0.2' strokeLinecap='round' />
        <rect x='60.25' y='38.25' width='16.5' height='10.5' rx='0.25' stroke='#BF0040' strokeWidth='0.5' />
      </g>
      <defs>
        <clipPath id='clip0_3126_59425'>
          <rect width='150' height='80' rx='2' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BigDamageChoosenIcon;
